import React, { useState, useEffect } from 'react';
import { formatCurrency, parseCurrency } from '../../../utils/SamuiUtils';
import { formatThaiDateUi } from '../../../utils/DateUtils';
import Datetime from 'react-datetime';
import moment from 'moment';

const BilSoModal = ({ showSoModal, handleSoClose, bilDatalist, soDataList, onConfirmSoSelection, arId }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [filteredSoDataList, setFilteredSoDataList] = useState([]);
    const [documentType, setDocumentType] = useState('all');

    const getCombinedList = () => [
        ...soDataList.map(item => ({ ...item, Type: 'SO' })),
        ...bilDatalist.map(item => ({ ...item, Type: 'BIL' })),
    ];
    useEffect(() => {
        const combinedList = getCombinedList();
        const upperDocType = documentType.toUpperCase();
        const lowerSearch = searchTerm.toLowerCase();

        const filtered = combinedList.filter(doc => {
            const typeMatch = documentType === 'all' || doc.Type?.toUpperCase() === upperDocType;
            const searchMatch =
                doc.Doc_No?.toLowerCase().includes(lowerSearch) ||
                doc.AR_Name?.toLowerCase().includes(lowerSearch);
            const arMatch = parseCurrency(doc.AR_ID) === parseCurrency(arId);

            const docDate = moment(doc.Doc_Date);
            const dateMatch = (
                (!startDate && !endDate) ? true :
                    (startDate && !endDate) ? docDate.isSameOrAfter(moment(startDate).startOf('day')) :
                        (!startDate && endDate) ? docDate.isSameOrBefore(moment(endDate).endOf('day')) :
                            docDate.isBetween(moment(startDate).startOf('day'), moment(endDate).endOf('day'), 'day', '[]')
            );

            return typeMatch && searchMatch && arMatch && dateMatch;
        });

        setFilteredSoDataList(filtered);
    }, [searchTerm, startDate, endDate, documentType, soDataList, bilDatalist, arId]);

    useEffect(() => {
        if (showSoModal) {
            setSearchTerm('');
            setSelectedItems([]);
            setStartDate(null);
            setEndDate(null);
        }
    }, [showSoModal]);

    const handleCheckboxChange = (so) => {
        const updatedSelectedItems = selectedItems.some(item => item.Doc_No === so.Doc_No)
            ? selectedItems.filter(item => item.Doc_No !== so.Doc_No)
            : [...selectedItems, so];
        setSelectedItems(updatedSelectedItems);
    };

    const handleConfirmSelection = () => onConfirmSoSelection(selectedItems);

    const clearSelection = () => setSelectedItems([]);

    return (
        <>
            <div className={`modal ${showSoModal ? 'show' : ''}`} style={{ display: showSoModal ? 'block' : 'none' }} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">รายชื่อใบขาย</h5>
                            <button type="button" className="close" onClick={handleSoClose}>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-3">
                                    <div className="form-group">
                                        <span className="fw-bold">ประเภทเอกสาร</span>
                                        <select
                                            className="form-control"
                                            value={documentType}
                                            onChange={(e) => setDocumentType(e.target.value)}
                                        >
                                            <option value="so">ใบกำกับภาษี (Invoice)</option>
                                            <option value="bil">ใบวางบิล (Billing Note)</option>
                                            <option value="all">ทั้งหมด</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-5">
                                    <div className="form-group">
                                        <span className="fw-bold">ค้นหาเอกสาร</span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder={documentType === 'bil' ? 'ค้นหาเลขที่ใบวางบิล' : 'ค้นหาเลขที่ใบกำกับภาษี'}
                                            value={searchTerm || ''}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <span className="fw-bold">วันที่เริ่มต้น</span>
                                        <Datetime
                                            value={startDate}
                                            dateFormat="DD-MM-YYYY"
                                            timeFormat={false}
                                            onChange={(date) => setStartDate(date && moment.isMoment(date) ? date : null)}
                                            inputProps={{ readOnly: true }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <span className="fw-bold">วันที่สิ้นสุด</span>
                                        <Datetime
                                            value={endDate}
                                            dateFormat="DD-MM-YYYY"
                                            timeFormat={false}
                                            onChange={(date) => setEndDate(date && moment.isMoment(date) ? date : null)}
                                            inputProps={{ readOnly: true }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                                <table className="table table-striped table-hover">
                                    <thead className="thead-dark">
                                        <tr>
                                            <th className="text-center" style={{ width: '1%' }}>
                                                <input
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                        const checked = e.target.checked;
                                                        setSelectedItems(checked ? filteredSoDataList : []);
                                                    }}
                                                    checked={filteredSoDataList.length > 0 && selectedItems.length === filteredSoDataList.length}
                                                />
                                            </th>
                                            <th className="text-center" style={{ width: '15%' }}>
                                                {documentType === 'bil' ? 'เลขที่ใบวางบิล' : 'เลขที่ใบกำกับภาษี'}
                                            </th>
                                            <th className="text-center" style={{ width: '10%' }}>วันที่เอกสาร</th>
                                            <th className="text-center" style={{ width: '32%' }}>ชื่อลูกค้า</th>
                                            <th className="text-center" style={{ width: '32%' }}>รายละเอียดเอกสาร</th>
                                            <th className="text-center" style={{ width: '10%' }}>ราคารวม</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredSoDataList.length > 0 ? (
                                            filteredSoDataList.map((so, index) => (
                                                <tr
                                                    key={so.Doc_ID || index + 1}
                                                    onClick={() => handleCheckboxChange(so)}
                                                    style={{
                                                        cursor: 'pointer',
                                                        backgroundColor: selectedItems.some(item => item.Doc_No === so.Doc_No) ? 'rgb(105, 188, 216)' : 'transparent',
                                                        transition: 'background-color 0.3s ease',
                                                    }}
                                                >
                                                    <td className="text-center">
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedItems.some(item => item.Doc_No === so.Doc_No)}
                                                            onChange={() => handleCheckboxChange(so)}
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                    </td>
                                                    <td className="text-center">{so.Doc_No}</td>
                                                    <td className="text-center">{formatThaiDateUi(so.Doc_Date)}</td>
                                                    <td className="text-left">{so.AR_Name}</td>
                                                    <td className="text-left">{so.Doc_Remark1}</td>
                                                    <td className="text-end">{formatCurrency(so.NetTotal || so.BL_Net_Total)}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="7">
                                                    <center><h5>ไม่พบข้อมูล</h5></center>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-primary" onClick={handleConfirmSelection}>ยืนยันการเลือก</button>
                            <button className="btn btn-danger" onClick={clearSelection}>ยกเลิกการเลือก</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BilSoModal;
